const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Arbeitszeit',
        },
      },
    },
  },
};

export default layout;
